import { FC } from 'react';
import photo from 'images/icons/photo.svg';

import styles from './clickToUploadImage.module.less';

const ClickToUploadImage: FC = () => {
  return (
    <div className={styles.uploadImageWrapper}>
      <div className={styles.imageIcon}>
        <img src={photo} alt="Upload Image" />
      </div>
      <div className={styles.linkHotspot}>
        <strong>+</strong>Click to Upload Image
      </div>
    </div>
  );
};

export default ClickToUploadImage;
